import api from './api'

// Subset of the tenant vertical config exposed to the payer portal via
// GET /portal/context. Kept local (not @lipaflow/shared VerticalConfig)
// because the portal endpoint intentionally returns a trimmed payload.
export interface PortalVerticalLabels {
  payer: string
  entity: string
  obligation: string
  period: string
  entity_reference: string
}

export interface PortalContextResponse {
  tenant_name: string
  vertical_code: string | null
  labels: PortalVerticalLabels
  features: Record<string, boolean>
}

/**
 * Neutral fallback used only when no shell supplied a default and the server's
 * per-tenant context is unavailable. The vertical-flavoured defaults live in
 * their own Tier 2 packages (`@lipaflow/education`, `@lipaflow/rental`) and
 * reach here through the shell's module (ADR-0004).
 */
export const NEUTRAL_PORTAL_CONTEXT: PortalContextResponse = {
  tenant_name: '',
  vertical_code: null,
  labels: {
    payer: 'Payer',
    entity: 'Account',
    obligation: 'Charge',
    period: 'Billing Period',
    entity_reference: 'Reference',
  },
  features: {},
}

export async function getPortalContext(): Promise<PortalContextResponse> {
  const res = await api.get('/context')
  const data = res.data ?? {}
  return {
    tenant_name: data.tenant_name ?? NEUTRAL_PORTAL_CONTEXT.tenant_name,
    vertical_code: data.vertical_code ?? NEUTRAL_PORTAL_CONTEXT.vertical_code,
    labels: { ...NEUTRAL_PORTAL_CONTEXT.labels, ...(data.labels ?? {}) },
    features: data.features ?? {},
  }
}
